<template>
  <section class="cont mt-5 bg">
    <div class="row justify-content-center text-center">
      <div class="col-12">
        <p class="header">ADVICE #{{advice.id}}</p>
        <h1 class="p-3">"{{advice.advice }}"</h1>
        <img
          class="img-fluid mt-3 mb-5"
          src="../assets/images/pattern-divider-desktop.svg"
          alt="img"
        />
      </div>
      <div @click="callingAdvice" class="dice-container">
        <img src="../assets/images/icon-dice.svg" alt="icon-dice" :class="['dice-img', { 'shake': shaking }]" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      advice: '',
      shaking: false
    };
  },
  methods: {
    async callingAdvice() {
      try {
        this.shaking = true; 
        const response = await fetch("https://api.adviceslip.com/advice");
        if (!response.ok) {
          throw new Error("API response was not ok");
        }

        const data = await response.json();
        const { slip } = data;
        this.advice = slip;
        setTimeout(() => {
          this.shaking = false; 
        }, 500);
      } catch (error) {
        console.error("Error fetching advice:", error);
      }
    },
  },
  mounted() {
    this.callingAdvice(); 
  },
};
</script>


<style>
p,
h1 {
  color: var(--Light-Cyan);
}

.bg {
  background: var(--Grayish-Blue);
  border-radius: 20px;
}

.cont {
  width: 100%;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 576px) {
  .cont {
    max-width: 540px;
  }
}

.header {
  color: var(--Neon-Green);
  font-size: 14px;
  margin: 2rem;
  letter-spacing: 0.3rem;
}

.dice-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.dice-container::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  padding: 15px;
  height: 30px;
  width: 30px;
  box-sizing: content-box;
  background-color: var(--Neon-Green);
}

.dice-img {
  display: block;
  width: 24px; /* Ajusta el tamaño de la imagen según sea necesario */
  height: 24px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(5px);
  }
}

.shake {
  animation: shake 0.5s ease-in-out;
}
</style>
